<template lang="html">

  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg h-100">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto box-login">
          <div class="auth-form-dark text-left p-5">
            <div class="text-center mb-5">
              <img src="@/assets/images/consulta-ja-logo.svg" width="50%" alt="Consulta Já" />
            </div>
            <h2>Olá, vamos começar?</h2>
            <h4 class="font-weight-light">Informe o seu e-mail e senha de acesso ao Consulta Já</h4>
            <form class="pt-5" autocomplete="off">
              <form autocomplete="off">
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input type="email" v-model="email" class="form-control" id="email" @keyup.enter="login">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label for="password">Senha</label>
                  <input type="password" v-model="password" class="form-control" id="password" @keyup.enter="login">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="mt-5">
                  <a class="btn btn-block btn-primary btn-lg font-weight-medium" @click="login">Login</a>
                </div>
                <div class="mt-3 text-center">
                  <router-link to="/esqueci-a-senha" class="forgot-password-link mt-3">Esqueci a senha</router-link>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
export default {
  data () {
    return {
      leavingPage: false,
      isLoading: null,

      email: '',
      password: ''
    }
  },
  created: function () {
    if (this.api.isLogged()) {
      this.eventBus.$emit('IS_LOGGED', true);
      if (this.api.hasOnboarded()) {
        this.$router.push('/dashboard');
      }
      else {
        this.$router.push('/primeiros-passos');
      }
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });
  },
  methods: {
    login () {
      this.eventBus.$emit('IS_LOADING', true);
      this.api.login({ email: this.email, password: this.password }).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        if (res.data.hasOwnProperty('accessToken')) {
          let userData = res.data.user;

          localStorage.setItem('accessToken', res.data.accessToken);
          localStorage.setItem('user', JSON.stringify(userData));

          // this.$intercom.update({
          //   user_id: userData.person.id,
          //   name: userData.person.name,
          //   email: userData.person.email,
          //   "client_id": userData.person.client.id,
          //   "client_name": userData.person.client.name
          // });
          if(window.Tawk_API && window.Tawk_API.setAttributes) {
            this.setTawkToUser(userData);
          }
          else {
            const scope = this;
            window.Tawk_API.onLoad = function () {
              scope.setTawkToUser(userData);
            };
          }

          this.eventBus.$emit('IS_LOGGED', true);
          window.location.reload();
        }
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        let response = err.response;
        let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';

        this.$swal('Ops...', message, 'error');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error', err);
      })
    },

    setTawkToUser(user) {
      try {
        window.Tawk_API.setAttributes({
          id: user.person.id,
          name: user.person.name,
          email: user.person.email,
          clientId: user.person.client.id,
          clientName: user.person.client.name
          // 'hash': user.emailHmac
        }, function(error){
          if(error) {
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error', error);
          }
        });
      } catch(err) {
        console.log('TawkTo Error', err);
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.leavingPage = true;
    next();
  }
}
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  background-image: linear-gradient(to bottom right, #eaeaea , #cccccc);

  .login-full-bg {
    background: url(../assets/images/bg-login.jpg) center center;
  }

  .box-login {
    font-family: 'sf_pro_displaymedium';
    background-color: $bunting;
    color: #ffffff;
  }

  .forgot-password-link {
    color: #ffffff;
    font-size: 18px;
  }
}
</style>
